import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
export default {
  components: {HeadDetailsGama},
  name: 'ValueEnterprise',
  props: ['selectedComissao']
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/valueenterprise/valueEnterprise.js